import React, { Component } from 'react';
import './Products.scss';
import Product from '../Product/index';
// import data from '../../../bikerentals.json';
import { ProductConsumer } from '../../../Context';

class Products extends Component {
  // state = { products: data.products };
  render() {
    return (
      <div>
        <div className='intro-text'>
          <p>Select items & adjust quantities in cart.</p>
          <p className='bold intro-text__large'>
            (Must select at least 1 corgi!)
          </p>
        </div>
        <ul className='product-list'>
          <ProductConsumer>
            {value => {
              return value.products.map(product => {
                return <Product key={product.id} product={product} />;
              });
            }}
          </ProductConsumer>
        </ul>
      </div>
    );
  }
}

export default Products;
